import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import SocialMediaShare from "../social-media-share";
import "./imagecaption.m.css";
import { extractTextFromHtml } from "../../helper/utils";
import Share from "../../atoms/other-icons/Share";

function ImagewithCaption({ element, story }) {
  const [toggleSharing, setToggleSharing] = useState(false);

  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  useEffect(() => {
    if (window) {
      window.dataLayer.push({
        event: "photoStory"
      });
    }
  }, []);

  return (
    <>
      <div styleName="wrapper">
        <div styleName="share-icon">
          <button className="share" styleName="share" onClick={sharingHandler}>
            <Share color="black" height="18px" width="18px" />
          </button>
          <div styleName="share-options">{toggleSharing && <SocialMediaShare story={story} />}</div>
        </div>
        {/* <StoryElement story={story} element={element} imageWidths={[420, 900]} /> */}
        <ResponsiveImage
          story={story}
          slug={decodeURIComponent(element["image-s3-key"])}
          metadata={element.metadata}
          defaultWidth={400}
          widths={[400, 900]}
          sizes="(max-width: 1024px) 1vw, 100vw"
          imgParams={{ auto: ["format", "compress"], fit: "max", q: 70 }}
          alt={extractTextFromHtml(element?.title) || element["image-attribution"] || ""}
        />
      </div>
      {element.title && <div styleName="image-caption-text" dangerouslySetInnerHTML={{ __html: `${element.title}` }} />}
      {element["image-attribution"] && (
        <span styleName="image-attribute" dangerouslySetInnerHTML={{ __html: element["image-attribution"] }} />
      )}
    </>
  );
}

ImagewithCaption.propTypes = {
  element: object,
  story: object
};

export default ImagewithCaption;
